module.exports = __webpack_public_path__ + "img/FAQ-off.950002ce.png";